export const typesOfFinancialInstitution = [
  { label: 'Casino/Card Club', value: 'Casino/Card Club' },
  { label: 'Depository institution', value: 'Depository institution' },
  { label: 'MSB', value: 'MSB' },
  { label: 'Securities/Futures', value: 'Securities/Futures' },
  { label: 'Other', value: 'Other' }
]
